import {Grid, Stack, Typography} from '@mui/material';
import React, {Children} from 'react';

type TnnReviewFieldProps = {
  label: string;
  value: React.ReactNode;
  density?: 'detail' | 'quick';
  noWrap?: boolean;
  title?: string;
};

const reviewFieldLabelStyles = {
  color: 'text.secondary',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '20px',
};

const reviewFieldValueStyles = {
  color: 'text.primary',
  fontSize: 16,
  lineHeight: '24px',
};

export const tnnValueOrDash = (value: React.ReactNode): React.ReactNode => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return String(value);
  }

  return value;
};

export const TnnReviewField = ({
  label,
  value,
  density = 'detail',
  noWrap = false,
  title,
}: TnnReviewFieldProps) => (
  <Stack spacing={0.5} sx={{minWidth: 0}}>
    <Typography
      sx={{
        ...reviewFieldLabelStyles,
        ...(density === 'quick' ? {fontSize: 16, lineHeight: 'normal'} : {}),
      }}>
      {label}
    </Typography>
    <Typography
      noWrap={noWrap}
      title={title ?? (typeof value === 'string' ? value : undefined)}
      sx={{
        ...reviewFieldValueStyles,
        ...(density === 'quick' ? {fontWeight: 500, lineHeight: 'normal'} : {}),
        wordBreak: noWrap ? 'normal' : 'break-word',
      }}>
      {tnnValueOrDash(value)}
    </Typography>
  </Stack>
);

export const TnnReviewGrid = ({children}: {children: React.ReactNode}) => (
  <Grid container spacing={3}>
    {Children.toArray(children).map((child, index) => (
      <Grid item key={index} xs={12} md={4}>
        {child}
      </Grid>
    ))}
  </Grid>
);
